import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Users, ChevronRight } from "lucide-react";
import useFeatures from "../../hooks/useFeatures";
import api from "../../api";

// Team caseload (backend GET /my-team): each supervisee's caseload, this
// week's sessions, high-risk patients and notes waiting. Shown as a section
// of Team Overview (/supervisor/dashboard) while "supervision" is on; the old
// /my-team page redirects there.
export default function TeamCaseload() {
  const features = useFeatures();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const on = features.has("supervision");
  useEffect(() => { if (on) api.getMyTeam().then((r) => setData(r.data)).catch(() => setData({ members: [] })); }, [on]);
  if (!on) return null;
  return (
    <div className="bg-white rounded-xl border border-secondary-100 shadow-sm overflow-hidden">
      <div className="px-6 py-4 border-b border-secondary-100 flex flex-wrap items-center justify-between gap-2">
        <div>
          <h3 className="font-bold text-secondary-800 flex items-center gap-2"><Users className="w-4 h-4 text-primary-500" />Caseload</h3>
          <p className="text-sm text-secondary-500">Patients, this week's sessions and notes waiting, per clinician.</p>
        </div>
        {features.has("risk") && (
          <button type="button" onClick={() => navigate("/risk-register")} className="text-xs text-primary-600 hover:underline flex items-center gap-1">
            Risk register <ChevronRight className="w-3.5 h-3.5" />
          </button>
        )}
      </div>
      {!data ? <p className="p-6 text-sm text-secondary-500">Loading…</p> : !data.members.length ? (
        <p className="p-6 text-sm text-secondary-600">Nobody reports to you yet. An organisation admin adds supervisees under People → Supervisors.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-secondary-50 text-left text-xs uppercase tracking-wide text-secondary-600">
              <tr><th className="px-4 py-3">Clinician</th><th className="px-4 py-3 text-right">Patients</th><th className="px-4 py-3 text-right">Sessions this week</th><th className="px-4 py-3 text-right">High risk</th><th className="px-4 py-3 text-right">Notes to review</th><th className="px-4 py-3 text-right">Unsigned &gt; 24h</th></tr>
            </thead>
            <tbody className="divide-y divide-secondary-100">
              {data.members.map((m) => (
                <tr key={m.user_id}>
                  <td className="px-4 py-3 font-semibold text-secondary-900">{m.name}</td>
                  <td className="px-4 py-3 text-right">{m.patients}</td>
                  <td className="px-4 py-3 text-right">{m.sessions_this_week}</td>
                  <td className={`px-4 py-3 text-right ${m.high_risk ? "font-bold text-rose-700" : ""}`}>{m.high_risk}</td>
                  <td className={`px-4 py-3 text-right ${m.notes_to_review ? "font-bold text-amber-700" : ""}`}>{m.notes_to_review}</td>
                  <td className={`px-4 py-3 text-right ${m.unsigned_notes ? "font-bold text-amber-700" : ""}`}>{m.unsigned_notes}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
